// extracted by mini-css-extract-plugin
export default {"itpStyleWrapper":"styles__itpStyleWrapper__ea22cd81d72549b06d91"};